import {CategoryHighlightSection_Element_Body} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/sections.types';
import {ProductImage} from '@aboutyou/ui-components';
import React, {useEffect} from 'react';
import styled from 'styled-components';

export const CategoryHighlightSectionProductListView: React.FC<{
  body: CategoryHighlightSection_Element_Body;
  setCardProductIds: (productIds: number[]) => void;
}> = ({body, setCardProductIds}) => {
  useEffect(() => {
    /**
     * Store product IDs for URL enhancement in category highlight cards.
     *
     * Products in CategoryHighlightSectionCard are loaded asynchronously (deferred).
     * Once loaded via useGetCategoryHighlightCardProducts, we store the product IDs
     * so they can be used to build the card's URL with firstProductId=(id1;id2;id3) parameter.
     *
     * The CategoryHighlightSectionCard component then retrieves these IDs
     * to build the final enhanced URL.
     */
    // eslint-disable-next-line local-rules/set-state-in-use-effect
    setCardProductIds(body.productIds);
  }, [body, setCardProductIds]);

  return (
    <Wrapper>
      {body.images.slice(0, 3).map(image => (
        <StyledProductImage
          padded
          key={image.src}
          src={image.src}
          alt={image.description}
          widths={[120, 220, 360]}
          breakpoints={[{columns: 3}]}
        />
      ))}
    </Wrapper>
  );
};

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2px;
`;

const StyledProductImage = styled(ProductImage)`
  &&& {
    border-radius: unset;

    > img {
      max-width: 80%;
      max-height: 80%;
    }
  }
`;
